import React from 'react';
import { User } from 'lucide-react';

const TenantAdminAccountForm = ({
  mode = 'create',
  tenant = {},
  adminName = '',
  adminEmail = '',
  adminPassword = 'Admin@123456',
  newPassword = '',
  confirmPassword = '',
  loading = false,
  onBack,
  onAdminNameChange,
  onAdminPasswordChange,
  onNewPasswordChange,
  onConfirmPasswordChange,
  submitLabel,
}) => {
  const isViewMode = mode === 'view';

  return (
    <div className="card space-y-4">
      <div className="flex items-center gap-3 mb-2">
        <User className="w-5 h-5 text-primary-600" />
        <h2 className="text-lg font-semibold">Tenant Admin Account</h2>
      </div>

      <p className="text-sm text-gray-500 bg-blue-50 p-3 rounded-lg border border-blue-100">
        {isViewMode ? (
          <>
            Review the tenant admin account below. Organization, plan and admin details are read-only.
          </>
        ) : (
          <>
            This account will be the administrator of the <strong>{tenant.name}</strong> workspace.
            The email will be set to <strong>{tenant.contactEmail}</strong>.
          </>
        )}
      </p>

      <div>
        <label className="label">Admin Display Name *</label>
        <input
          className="input"
          placeholder="John Smith"
          value={adminName}
          onChange={e => onAdminNameChange?.(e.target.value)}
          required
          readOnly={isViewMode}
        />
      </div>

      {isViewMode && (
        <div>
          <label className="label">Admin Email *</label>
          <input
            type="email"
            className="input"
            value={adminEmail}
            readOnly
          />
        </div>
      )}

      {isViewMode ? (
        <>
          <div>
            <label className="label">New Password *</label>
            <input
              type="password"
              className="input"
              value={newPassword}
              onChange={e => onNewPasswordChange?.(e.target.value)}
              required
            />
          </div>
          <div>
            <label className="label">Confirm Password *</label>
            <input
              type="password"
              className="input"
              value={confirmPassword}
              onChange={e => onConfirmPasswordChange?.(e.target.value)}
              required
            />
          </div>
        </>
      ) : (
        <div>
          <label className="label">Initial Password *</label>
          <input
            type="text"
            className="input"
            value={adminPassword}
            onChange={e => onAdminPasswordChange?.(e.target.value)}
            required
          />
          <p className="text-xs text-gray-400 mt-1">Share this with the tenant admin. They should change it on first login.</p>
        </div>
      )}

      <div className="bg-gray-50 rounded-lg p-4 space-y-2 text-sm border border-gray-200">
        <h3 className="font-semibold text-gray-700 mb-3">Summary</h3>
        <div className="grid grid-cols-2 gap-2 text-sm">
          <span className="text-gray-500">Organization</span><span className="font-medium">{tenant.name || '-'}</span>
          <span className="text-gray-500">Slug</span><span className="font-medium font-mono">{tenant.slug || '-'}</span>
          <span className="text-gray-500">Plan</span><span className="font-medium capitalize">{tenant.plan || '-'}</span>
          <span className="text-gray-500">Contact</span><span className="font-medium">{tenant.contactEmail || tenant.contact_email || '-'}</span>
          <span className="text-gray-500">Max Users</span><span className="font-medium">{tenant.maxUsers ?? tenant.max_users ?? '-'}</span>
          <span className="text-gray-500">Storage</span><span className="font-medium">{((tenant.maxStorageMb ?? tenant.max_storage_mb) !== undefined && (tenant.maxStorageMb ?? tenant.max_storage_mb) !== null) ? `${tenant.maxStorageMb ?? tenant.max_storage_mb} MB` : '-'}</span>
        </div>
      </div>

      <div className="flex justify-between pt-2">
        {onBack ? (
          <button type="button" onClick={onBack} className="btn-secondary">← Back</button>
        ) : (
          <span />
        )}
        <button type="submit" disabled={loading} className="btn-primary">
          {loading && null}
          {submitLabel || (isViewMode ? 'Update Password' : '✓ Create Tenant')}
        </button>
      </div>
    </div>
  );
};

export default TenantAdminAccountForm;
